var exports = {
  "L": "IncomingCallManager.module__portalRoot___Zk1SRH",
};

module.exports = exports;
